export const OrderStatusEnum = {
  Received: 'received',
  Preparing: 'preparing',
  Ready: 'ready',
  Sent: 'sent',
  Retrieved: 'retrieved',
  Expired: 'expired',
};
